import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
  selector: 'fin-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrl: './chart-legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLegendComponent {
  @HostBinding('class') classAttribute = 'flex flex--center';

  @Input({ required: true })
  text$: Observable<string>;
}
